import { PricerModes } from '@pages/Pricers/enums';

import { PagesPermissions } from './PagesPermissions';

export const PricerPagePermissions: Record<PricerModes, PagesPermissions> = {
  [PricerModes.interestRate]: PagesPermissions.irPricer,
  [PricerModes.fx]: PagesPermissions.fxPricer,
  [PricerModes.inflation]: PagesPermissions.inflationPricer,
  [PricerModes.commodity]: PagesPermissions.commodityPricer,
  [PricerModes.debt]: PagesPermissions.debtPricer,
  [PricerModes.custom]: PagesPermissions.customPricer,
};
